import { ChangeDetectorRef,HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges,AfterViewInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';

import {FilterByUser} from '../../pipes/search';

import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';

import{UserService} from '../../services/user.service';
import { createViewChild } from '@angular/compiler/src/core';

import {NewsletterService} from '../../services/newsletter.service';

import {UserpermissionService} from '../../services/userpermission.service';

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {NgbdModalBasic} from '../../dashboard/modals/calender_invite_modal/invite_modal.component';
import {IRule} from '../../irule';
import {HomeService} from '../../services/home.service';
import{ArticleService} from '../../services/article.service';
declare var $:any;//Required for jquery use

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class UserManagementComponent extends BaseComponent implements OnInit,OnDestroy,AfterViewInit,IRule {
  
  user:any;

  url:any=AppSettings.API_ENDPOINT;

  manage_User:any=[];

  msg:any;

  toastr:any;

 _router:any;

  userName='';
  navigationsType=[];

  token:any='';

  userMgmtList:Array<any> = [];
  externalUserMgmtList:Array<any> = [];

  roleList:Array<any>= [];
  //   {key:'admin',value:'Admin'},
  //   {key:'editor',value:'Editor'},
  //   {key:'contributor',value:'Contributor'},
  //   {key:'distributor',value:'Distributor'},
  //   {key:'user',value:'User'},
  //   {key:'publisher',value:'Publisher'},
  //   {key:'reviewer',value:'Reviewer'},
  //   {key:'author',value:'Author'}
    
  // ];
  
  statusList:Array<any>= [

    {key:'Active',value:'active'},
    {key:'Inactive',value:'inactive'},
     
    
  ];
  // roleList:Array<any>= [];

  selectedRoleList:any=[];
  screenName:any=[]

  roleError:string;  

  searchTxt:any='';

  record_offset:number= 0;

  per_page:number=20;

  loader_image:boolean=true;

  user_Service:any;  

  dropdownSettings = {};
  dropdownSettings2 = {};

  selectedRole:Array<any> = [];
  selectedStatus:Array<any> = [];

  marked = false;

  record_empty:number =0;

  notification:any=[];

  selectedStatusSrh:any=[];

  selectedRoleSrh:any=[];

  currentTab:number=1;
  pendingExternal:number=0;
  departmentList:any=[]
  deletedUserId:any=0
  selectedExStatus:any=[]
  isExternalParams=false

  onRoleSelectSrh($event){

    this.record_offset=0;
   
    this.searchUserList();


  } 
  onRoleSelectAllSrh($event){

   

  }
  onRoleDeSelectSrh($event){


    this.record_offset=0;

    this.searchUserList();

    



  }
  onRoleDeSelectAllSrh($event){

   
  }  

  onStatusSelectSrch($event){
    this.record_offset=0;

    this.searchUserList();


  }

  

  @HostBinding('style.width') public width: string = '100%';//for edge browser design issue  


  getselectedRole(i:number){

 
    return this.roleList.filter( (roleI) => { return roleI.key == this.userMgmtList[i].role}); 


  }

  
  getselectedStatus(i:number){

 
    return this.statusList.filter( (statusI) => { return statusI.key == this.userMgmtList[i].status}); 


  }



  

  constructor(private articleService:ArticleService,private modalService: NgbModal , homeservice:HomeService,private userpermissionService:UserpermissionService,msg:MessageService, toastr: ToastrService, _router: Router,private userService:UserService,private _activatedRoute: ActivatedRoute) { 
    
    super(msg,toastr,homeservice,_router);

    this.msg=msg;
    this.toastr=toastr;
    this._router=_router;
    // this.user_Service=userService;
    //this.newsletterService = newsletter;

    

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      this.token = tokenA.token;

      this.pendingExternal = localStorage.getItem('pending_external') ? +localStorage.getItem('pending_external') : 0;


    let data = {
			token:this.token,
     
			//limit:this.per_page,				
		}

    this.userpermissionService.roleList(data).subscribe( (roleres)=>{

 
      if(roleres.status=='success'){	


       if(roleres.user!=undefined){
        this.user =roleres.user;
       }
        
        if(roleres.permissions){

          roleres.permissions.map((x)=>{
            let obj ={}
            obj['key'] = x.role;
            obj['value'] = x.role.toUpperCase()
            this.roleList.push(obj)
          })

        }
      //  let data =  {key:'user',value:'USER'}
      //  this.roleList.push(data)
       
      }


    });

    let data2={
      token:tokenA.token,
      // limit:this.per_page,
      // 'page':'settings'
    }

    this.articleService.getUserGroup(data2).subscribe( (res)=>{

      if(res.status=='success'){
       
        this.departmentList=res.department;

        this.userName=res.user.name;
        this.navigationsType=res.navigation;
        this.notification =res.notification;
        this.broadcast_menu();

      }else{        
        this.toastr.error(res.message, '', {timeOut: 5000});
      }
    });

    this._activatedRoute.queryParams.subscribe(params =>{

      if(params.search!=undefined){
       
        this.searchTxt = params.search;
        // this.searchUserList()

      }
      if(params.external!=undefined){
       this.isExternalParams=true
       this.currentTab=2
      }
    })


    }catch(exc){
         
      this._router.navigate(['/vlogin']);

    }


  
 
  }
    
  ngOnInit() {



     this.userDataWithSearch();
   
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true
    }; 
    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      itemsShowLimit: 1,

      enableCheckAll:false
      //allowSearchFilter: true,
     // selectAllText: 'Select All',
     // unSelectAllText: 'UnSelect All'
    }; 
  }

 ngAfterViewInit(){


  if(this.isExternalParams){
     
      $("#tab-external").click()
      
      // $('#external').show()
      // $('#external').addClass("active")
      // $('#internal').hide()
      // $('#internal').removeClass("active")
      // $('#tab-external').addClass("active")
      // $('#tab-internal').removeClass("active")
   }
  
  $(window).on("scroll", function() {

    if(this._router.url == '/users'){


      if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
        
         if(this.record_empty == 0){

            this.record_offset+=this.per_page;
          
            this.searchUserList();


          }
        

      }




    }

  }.bind(this));

  $(document).ready(function(){
    $('body').on('click','.tooltip-custom',function(){

      $(this).tooltip("hide");
     

     });
     let tl:any= $('body');
     tl.tooltip({
      trigger: "hover" ,
      selector: '.tooltip-custom'
     });
  }.bind(this));

 }

  
 

  onStatusSelect(item: any,userid:any,index:any){

    if(this.currentTab==1){
      if(this.selectedStatus[index][0].key=='Inactive'){
      
        let data ={
          id:userid,
          inactive: true,
         
        }
        // if(this.currentTab==2){
        //   data['external'] = 1;
        // }
      
        this.changeUserMode(data)
      }else{
  
        let data ={
          id:userid,
          active: true,
         
        }
        
        this.changeUserMode(data)
  
      }

    }else{

      if(this.selectedExStatus[index][0].key=='Inactive'){
      
        let data ={
          id:userid,
          inactive: true,
          external:1
         
        }
       
        this.changeUserMode(data)
      }else{
  
        let data ={
          id:userid,
          active: true,
          external:1
        }
        if(this.currentTab==2){
          data['external'] = 1;
        }
       
        this.changeUserMode(data)
  
      }
    }
  
   

   

  }


  onRoleSelect(item: any,userid:any,index:any) {

    
    let role = []
    this.selectedRole[index].map((x)=>{
          if(x.key!=undefined){
            role.push(x.key)
          }else{
            role.push(x)
          }
          
    })

    let data ={
      id:userid,
      role:role
    }

    this.changeUserMode(data)
    
  }

  onRoleSelectAll(item: any,userid:any,index:any){

    this.roleError='';
    this.selectedRole = this.roleList;

    let role = []
    this.selectedRole.map((x)=>{
      if(x.key!=undefined){
        role.push(x.key)
      }else{
        role.push(x)
      }
    })

    let data ={
      id:userid,
      role:role
    }
    this.changeUserMode(data)

  }


  onRoleDeSelect(item: any,userid:any,index:any){

    
    if(this.selectedRole[index].length>0){
      let role = []
      this.selectedRole[index].map((x)=>{
        if(x.key!=undefined){
          role.push(x.key)
        }else{
          role.push(x)
        }
      })

      let data ={
        id:userid,
        role:role
      }
      this.changeUserMode(data)
    }else{
      this.toastr.warning('Please select role !', '', {timeOut: 3000});
    }
   
    
  }

  onRoleDeSelectAll(item: any,userid:any,index:any){

    this.toastr.warning('Please select role !', '', {timeOut: 3000});

      // this.selectedRoleList = []; 
     
      // let data ={
      //   id:userid,
      //   role:[]
      // }
      // this.changeUserMode(data)
    
  } 

  onScreenChanged(event,usrid,i){

    let data ={
      id:usrid,
      department:event.target.value
     
    }
  
    this.changeUserMode(data)
    
  }

  changeUserMode(user){

    //console.log(user);
    user.page='users';

    let data={
      token:this.token,
      reqData:user
    }


   // console.log(data);
    
    this.userService.UserUpdate(data).subscribe( (res)=>{

      
      if(res.status=='success'){


        this.toastr.success('User is updated !', '', {timeOut: 3000});


      } else{
        this.toastr.error('User update failed !', '', {timeOut: 3000});

      }


   });



  }


  openUserShare(){

 


   
   const modalRef1 = this.modalService.open(NgbdModalBasic,{ windowClass : "invite_popup"});

 
   modalRef1.componentInstance.UShare = true;

   modalRef1.componentInstance.newsletterI = [];
   

   modalRef1.componentInstance.passEntry.subscribe((receivedEntry) => {

   modalRef1.close();

 


     });

  }

  searchUserList(){

    this.loader_image=true;
    this.record_empty =1;
    //this.issearch=true;

     let data={}

     data['offset']=this.record_offset;
     data['limit']=this.per_page;     
     data['search'] = this.searchTxt;          
     data['page']='users'; 

    
     if(this.selectedStatusSrh.length > 0  ){

      data['ustatus'] = this.selectedStatusSrh[0].key ;

     }

     
     if(this.selectedRoleSrh.length > 0 ){

      

      let role = []
      this.selectedRoleSrh.map((x)=>{
        if(x.key!=undefined){
          role.push(x.key)
        }else{
          role.push(x)
        }
      })

      data['urole'] =role;


     }
 

     
     try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      let data2={
        token:tokenA.token,
        reqData:data
      }

      

      if(this.currentTab==1){
        this.userService.UserDataBySearchText(data2).subscribe( (response)=>{


          if(response.status=='success'){
  
            this.notification=response.notification;
            this.navigationsType =response.navigation
  
            this.msg.sendMessage({'user':response.user.name,'notification':response.notification,'type':'left_menu_link','navigations':response.navigation});
  
            this.loader_image =false;
       
           if(this.record_offset ==0  ){
  
            this.record_empty =0;
  
            this.userMgmtList=response.users;     
           
  
            if(this.userMgmtList!=undefined){
  
  
              this.userMgmtList.map((x,i)=>{
              
                 this.selectedRole[i]  = x.role;
                 this.selectedStatus[i] = this.statusList.filter( (statusI) => { return statusI.key == x.status});
                 this.screenName[i]= x.department
              })
    
  
            }
  
  
           } else if(this.record_offset !=0 &&response.users==undefined){
  
             
            this.record_empty =1;
  
  
           } else{
  
  
            this.record_empty =0;
  
            response.users.forEach( (item,i)=>{
  
              this.userMgmtList.push(item);            
              
            });
            
                      
            this.userMgmtList.forEach( (item,i)=>{
  
              this.selectedRole[i] = this.roleList.filter( (roleI) => { return roleI.key == item.role}); 
              this.selectedStatus[i] = this.statusList.filter( (statusI) => { return statusI.key == item.status});
              this.screenName[i]= item.department
    
              });
  
           }
  
          
          }else{          
          this.loader_image =false;        
  
          this.toastr.error('User Not Found  !', '', {timeOut: 3000});
          }
  
        })
      }else{
        data['external'] = 1;
        let data3={
          token:tokenA.token,
          reqData:data
        }
        this.userService.UserDataBySearchText(data3).subscribe( (response)=>{
          if(response.status=='success'){
            this.loader_image =false;
            if(this.record_offset ==0  ){
  
              this.record_empty =0;
    
              this.externalUserMgmtList=response.users;  
              
              if(this.externalUserMgmtList){
                this.externalUserMgmtList.map((x,i)=>{
                  this.selectedExStatus[i] = this.statusList.filter( (statusI) => { return statusI.key == x.status});
                  
                })
              }
              
             
    
             } else if(this.record_offset !=0 &&response.users==undefined){
    
               
              this.record_empty =1;
    
    
             } else{
    
    
              this.record_empty =0;
    
              response.users.forEach( (item,i)=>{
    
                this.externalUserMgmtList.push(item);            
                
              });

              if(this.externalUserMgmtList){
                this.externalUserMgmtList.map((x,i)=>{
                  this.selectedExStatus[i] = this.statusList.filter( (statusI) => { return statusI.key == x.status});
                  
                })
              }
    
             }
            
          }else{
            this.loader_image =false;
            this.toastr.warning('User Not Found  !', '', {timeOut: 3000});
          }
        })
       
      }
      

    }catch(exec){

      this.loader_image =false;
      this.toastr.error('User Not Found  !', '', {timeOut: 3000});
    }

  }

  userDataWithSearch(){

      this.record_offset =0;
    
      this.searchUserList();
  }
  

  deleteRow(id){
    for(let i = 0; i < this.userMgmtList.length; ++i){
        if (this.userMgmtList[i]!=undefined && this.userMgmtList[i].id === id) {
            this.userMgmtList.splice(i,1);
        }
    }
  }


CheckAllOptions(event) {
 
  this.marked= event.target.checked;
  //console.log('event',this.marked);
  if ((this.userMgmtList.every(val => val.checked == true)) && (this.marked==false))
  {
    this.userMgmtList.forEach(val => { val.checked = false});
  }
  else if ((this.userMgmtList.every(val => val.checked == false)) && (this.marked==true))
  {
    this.userMgmtList.forEach(val => { val.checked = true});   
  }
  else if(this.marked==true)
  {
    this.userMgmtList.forEach(val => { val.checked = true});
  }
  else if(this.marked==false)
  {
    this.userMgmtList.forEach(val => { val.checked = false});
  }
  
}

broadcast_menu(){
    
  this.msg.sendMessage({'user':this.userName,'type':'left_menu_link','notification':this.notification,'navigations':this.navigationsType});
 
}
tab(id){
  this.currentTab = id;
  this.record_offset =0;
  this.record_empty =0;
  this.searchUserList();
}

profile(id){
 
  $('.tooltip-custom').tooltip("hide")
  this._router.navigate(['/user/profile']);

  this.msg.sendMessage({'type':'admin_user_edit',userId:id,roleList:this.roleList})
  
}

exprofile(id,usr){
 
  $('.tooltip-custom').tooltip("hide")
  this._router.navigate(['/user/exprofile']);

  let dataval={
    user:usr,
    'notification':this.notification,
    'navigation':this.navigationsType
  }
  
  this.msg.sendMessage({'type':'exprofile','userId':id,'external':1,'admin':true,data:dataval});
  
}

deletetUserList(id){

  this.deletedUserId =id
  $('#success-popup').modal('show');

}

deleteUser(){
 console.log(this.deletedUserId,this.currentTab)
 let user={}
  user['page']='users';
  user['id']=this.deletedUserId;
  user['archive']=true;
  

  let data={
    token:this.token,
    reqData:user
  }

   
  
  this.userService.UserUpdate(data).subscribe( (res)=>{

    
    if(res.status=='success'){

      this.toastr.success('User is deleted !', '', {timeOut: 3000});
      if(this.currentTab==1){
        let id= this.deletedUserId
        var index = this.userMgmtList.map(x => {
          return x.id;
        }).indexOf(id);
        
        this.userMgmtList.splice(index, 1);
        
      }else{
        
        let id= this.deletedUserId
        var index = this.externalUserMgmtList.map(x => {
          return x.id;
        }).indexOf(id);
        
        this.externalUserMgmtList.splice(index, 1);
      }

    } else{
      this.toastr.error('User delete failed !', '', {timeOut: 3000});

    }

  });
}
  
}
